var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo24 = function SvgInfo24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.832 7.334a1.167 1.167 0 1 1 2.334 0 1.167 1.167 0 0 1-2.334 0Zm0 3.5a1.167 1.167 0 0 1 2.333 0v5.833a1.167 1.167 0 0 1-2.333 0v-5.833Zm1.167 10.5c-5.146 0-9.334-4.187-9.334-9.333 0-5.147 4.188-9.334 9.334-9.334s9.333 4.187 9.333 9.334c0 5.146-4.187 9.333-9.333 9.333Zm0-21C5.555.334.332 5.557.332 12.001c0 6.443 5.223 11.666 11.667 11.666 6.442 0 11.666-5.223 11.666-11.666C23.665 5.557 18.441.334 12 .334Z",
    fill: "#008545"
  })));
};
export default SvgInfo24;